import { useSalon } from "@/main/components/common_features/salon/useSalon"
import { useSouhlAdminQuery } from "@/provider/apollo/Apollo"
import { ApolloContext } from "@/provider/apollo/context"
import { graphql } from "@/souhl_admin/gql/__generated__"

const getCurrentCompanyIdQuery = graphql(/* GraphQL */ `
	query GetCurrentCompanyIdForCompanyAdmin($param: CompanyBySalonIdParam!) {
		companyBySalonId(param: $param) {
			company {
				id
			}
		}
	}
`)

export const useCurrentCompanyId = () => {
	const context: ApolloContext = {
		disableErrorDialog: true, // NOTE: 現状 Home page で使用しており、souhl admin でない場合は 403 になっているため、dialog は出さない
	}
	const { currentSalonID } = useSalon()
	const { data, loading } = useSouhlAdminQuery(getCurrentCompanyIdQuery, {
		variables: {
			param: {
				salon_id: currentSalonID,
			},
		},
		fetchPolicy: "cache-first",
		context,
	})

	return {
		companyId: data?.companyBySalonId?.company?.id ?? null,
		loading,
	}
}
